module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(!_vm.doubleRoleComp) ? _c('div', [_c('h1', {
    staticClass: "text-center h4",
    staticStyle: {
      "font-weight": "600 !important",
      "font-family": "'Merriweather', serif !important"
    }
  }, [_vm._v("\n      Get paid to play with pets\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "text-center h4",
    staticStyle: {
      "font-weight": "600 !important",
      "font-family": "'Merriweather', serif !important"
    }
  }, [_vm._v("\n      100% commission free\n    ")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), (!_vm.checkUserComp) ? _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-sm-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg btn-block",
    staticStyle: {
      "font-family": "'Merriweather', serif !important"
    },
    on: {
      "click": function($event) {
        _vm.goSitterSignup()
      }
    }
  }, [_vm._v("\n          Get Started\n        ")]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.checkUserComp) ? _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-sm-offset-4"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-block btn-title",
    on: {
      "click": function($event) {
        _vm.confirmSwitchAccount()
      }
    }
  }, [_vm._v("\n        Switch Account\n      ")])]) : _vm._e()]) : _c('div', [_vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img img-responsive",
    attrs: {
      "src": "https://www.dupaws.com/services/images/site/become-a-sitter.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-5 col-sm-offset-2 col-xs-12"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "#00bd70"
    }
  }), _vm._v(" Set your own\n          price rates\n        ")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "#00bd70"
    }
  }), _vm._v(" Set your own\n          schedule and availability\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 col-xs-12"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "#00bd70"
    }
  }), _vm._v(" Get paid 100%\n          commission free.\n        ")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "#00bd70"
    }
  }), _vm._v(" Only accept pets\n          that match your preferrence.\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('h1', {
    staticClass: "text-center h4",
    staticStyle: {
      "font-weight": "600 !important",
      "font-family": "'Merriweather', serif !important"
    }
  }, [_vm._v("\n        How this work\n      ")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v("\n        It takes around 3 to 5 minutes to create a profile, once completed and\n        approved pet owners will be able to directly contact and book your\n        services.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("\n      Your account already registered as a sitter, go to\n      "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('strong', [_vm._v("account")])]), _vm._v(" to switch your role\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d307aaa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/BecomeSitter.vue
// module id = 647
// module chunks = 2